/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/features/admin-business-profiles/components/business-profile-grids-tab/business-profile-grids-tab.component.scss */
/*# sourceMappingURL=business-profile-grids-tab.component.css.map */
